import { Component, Input, EventEmitter, Output, OnChanges } from '@angular/core';
import { TaskService } from 'src/app/core/service/task.service';
import { Task } from 'src/app/case/model/task';
import { MessageHandlerService } from 'src/app/core/utility/message-handler.service';
import { TextProcessor } from 'src/app/core/utility/text.processor';
import { SettingService } from 'src/app/core/service/setting.service';

@Component({
  selector: 'app-task-priority',
  templateUrl: './task-priority.component.html',
  styleUrls: ['./task-priority.component.scss']
})
export class TaskPriorityComponent implements OnChanges
{
  @Input() public task: Task;
  @Input() public dialogOpened: boolean;

  @Output() public save = new EventEmitter<Task>();
  @Output() public closing = new EventEmitter();

  public priority: any;
  public urgentPriority: boolean;
  public shortTaskName: string;
  public loaded = false;
  public taskPriority: Array<{ id: string; text: string; value: number }>;

  constructor(
    private taskService: TaskService,
    private messageHandlerService: MessageHandlerService,
    private settingService: SettingService
  ) { }
  public ngOnChanges(): void
  {
    this.loaded = false;
    if (this.task !== null)
    {
      this.settingService.getCachedSessionSettings().subscribe({
        next: (data) =>
        {
          const priorities = data.taskPriorities.split(',');
          this.taskPriority = this.taskService.listPriorities.filter(priority => priorities.includes(priority.id));
          this.taskPriority.sort((a, b) => (a.value > b.value) ? -1 : 1);

          this.shortTaskName = TextProcessor.truncateText(this.task.name, 35);
          if (this.taskPriority.length === 2)
          {
            if (parseInt(this.task.priorityNumber, 10) === this.taskPriority[0].value)
            {
              this.urgentPriority = true;
            }
            else
            {
              this.urgentPriority = false;
            }
          }
          this.priority = this.taskPriority.find(x => x.id === this.task.priority);
          if (this.priority === undefined)
          {
            this.priority = this.taskPriority[this.taskPriority.length - 1];
          }
          this.loaded = true;
        }
      });
    }
  }

  public changePriority(): void
  {
    if (this.taskPriority.length === 2)
    {
      if (this.urgentPriority)
      {
        this.task.priority = this.taskPriority[0].text;
        this.task.priorityNumber = this.taskPriority[0].value.toString();
      }
      else
      {
        this.task.priority = this.taskPriority[1].text;
        this.task.priorityNumber = this.taskPriority[1].value.toString();
      }
    }
    else
    {
      this.task.priority = this.priority.text;
      this.task.priorityNumber = this.priority.value.toString();
    }

    this.taskService.updatePriority(this.task.id, this.task.priorityNumber.toString()).subscribe({
      next: () =>
      {
        this.messageHandlerService.displaySuccess('TASK-PRIORITY-UPDATED-SUCCESSFULLY');
        this.save.emit(this.task);
        this.dialogOpened = false;
      },
      error: error =>
      {
        this.messageHandlerService.displayError(error);
      }
    });
  }

  public closeDialog(): void
  {
    this.closing.emit();
  }
}
